import { Injectable } from "@angular/core";
import { SquadNumberDto, TeamShortDto, UpdateSquadNumbersRequestDto } from "app/models";
import { TeamCardsDto } from "app/models/dtos/team-cards.dto";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";
import { TeamCardDto } from "app/models/dtos/team-card.dto";

@Injectable()
export class TeamService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getForm(teamId: number): Observable<string> {
        return this.httpService.get<string>(this.apiUrl + 'teams/' + teamId + '/form', null);
    }

    getCards(teamId: number): Observable<TeamCardsDto> {
        return this.httpService.get<TeamCardsDto>(this.apiUrl + 'teams/' + teamId + '/cards', null);
    }

    getShortTeam(teamId: number): Observable<TeamShortDto> {
        return this.httpService.get<TeamShortDto>(this.apiUrl + 'teams/' + teamId + '/short', null);
    }

    getNationalShortTeam(teamId: number): Observable<TeamShortDto> {
        return this.httpService.get<TeamShortDto>(this.apiUrl + 'teams/national/' + teamId + '/short', null);
    }

    getSquadNumbers(teamId: number): Observable<SquadNumberDto[]> {
        return this.httpService.get<SquadNumberDto[]>(this.apiUrl + 'teams/' + teamId + '/numbers', null);
    }

    getTeamCard(teamId: number): Observable<TeamCardDto> {
        return this.httpService.get<TeamCardDto>(this.apiUrl + 'teams/' + teamId + '/data', null);
    }

    updateSquadNumbers(request: UpdateSquadNumbersRequestDto) {
        return this.httpService.put(this.apiUrl + 'teams/squad-numbers' , null, request);
    }

}